import React from 'react';
import PersonnelSelect, { PersonnelSelectProps } from './PersonnelSelect';

// Wrapper that fixes mode to "code_only"
export type PersonnelCodeSelectProps = Omit<PersonnelSelectProps, 'mode'>;

const PersonnelCodeSelect: React.FC<PersonnelCodeSelectProps> = (props) => {
  return <PersonnelSelect {...props} mode="code_only" />;
};

export default PersonnelCodeSelect;
